import { Component, inject, input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { icons } from '../../assets/icons';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { IconSanitizerService } from './../../services/icon-sanitizer.service';

@Component({
    selector: 'lib-helper-info',
    templateUrl: './helper-info.component.html',
    styleUrls: ['./helper-info.component.scss'],
    imports: [IdGeneratorPipe]
})
export class HelperInfoComponent {
    private readonly iconSanitizer = inject(IconSanitizerService);

    readonly icons = icons;

    readonly message = input('');

    readonly helperInfoId = input<string>();

    readonly svg: SafeHtml = this.iconSanitizer.getIcon('unSaved');
}
